import {IconButton, Tooltip} from 'platform/components';
import {Icon} from 'platform/foundation';
import styled from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

import {CARVAGO_BRAND_COLOR} from '../../../constants/CARVAGO_BRAND_COLOR';

interface CarvagoActionButtonProps extends TestIdProps {
  hasUnifiedSurfaces: boolean;
  label: string;
  tooltip?: string;
  isInList: boolean;
  isDisabled: boolean;
  onClick: () => void;
}

export function CarvagoActionButton(props: CarvagoActionButtonProps) {
  if (!props.hasUnifiedSurfaces) {
    return (
      <Tooltip label={props.tooltip} isDisabled={!props.tooltip}>
        <IconButton
          size="small"
          priority="secondary"
          severity={props.isInList ? 'informational' : undefined}
          icon="custom/carvago"
          isDisabled={props.isDisabled}
          onClick={props.onClick}
          data-testid={props['data-testid']}
        />
      </Tooltip>
    );
  }
  return (
    <Tooltip label={props.tooltip ?? props.label}>
      <ActionButton
        $isInList={props.isInList}
        type="button"
        aria-label={
          props.isDisabled && props.tooltip ? `${props.label}. ${props.tooltip}` : props.label
        }
        aria-haspopup="dialog"
        aria-disabled={props.isDisabled}
        onClick={() => {
          if (!props.isDisabled) {
            props.onClick();
          }
        }}
        data-testid={suffixTestId('iconButton', props)}
      >
        <Icon value="custom/carvago" size={4} />
      </ActionButton>
    </Tooltip>
  );
}

const ActionButton = styled.button<{$isInList: boolean}>`
  color: ${({$isInList, theme}) => ($isInList ? CARVAGO_BRAND_COLOR : theme.colors.text.primary)};
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${({theme}) => theme.getSize(6)};
  height: ${({theme}) => theme.getSize(6)};
  border-radius: ${({theme}) => theme.radii.small};
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background: ${({theme}) => theme.colors.palettes.neutral[30][100]};
  }
  &:active {
    background: ${({theme}) => theme.colors.palettes.neutral[40][100]};
  }
  &:focus-visible {
    outline: ${({theme}) => theme.outline.default} ${({theme}) => theme.colors.general.accent};
    outline-offset: ${({theme}) => theme.outline.offset};
  }
  &[aria-disabled='true'] {
    opacity: 0.4;
    cursor: default;
    &:hover,
    &:active {
      background: transparent;
    }
  }
`;
